export default "__VITE_ASSET__725Qb$g4__"